import React, {useEffect} from "react";
import useInsuranceType from "../Stores/InsuranceStore";
interface InsuranceProps {
  displayValue: number;
  id?: string;
}
const InsuranceMenu: React.FC<InsuranceProps> = ({
  displayValue,
  id,
}): JSX.Element => {
  const insuranceValue = useInsuranceType((state) => state.insuranceValue);
  const setInsuranceValue = useInsuranceType(
    (state) => state.setInsuranceValue,
  );
  const disabledInsurance = useInsuranceType(
    (state) => state.disabledInsurance,
  );
  const insuranceList = useInsuranceType((state) => state.insuranceList);
  useEffect(() => {}, [displayValue]);
  return (
    <select
      id={id}
      className={`w-[45px] truncate lg:w-auto text-center lg:text-center px-1 xl:select xl:select-bordered text-[12px] text-center bg-[#E5DCDD] appearance-none focus:outline-none focus:ring-0 focus:border-transparent ${
        disabledInsurance ? "text-gray-400 opacity-60 cursor-not-allowed" : ""
      }`}
      defaultValue={insuranceValue}
      onChange={(event) => setInsuranceValue(Number(event.target.value))}
      disabled={disabledInsurance}>
      {insuranceList.map((label, index) => (
        <option key={index} value={index}>
          {label}
        </option>
      ))}
    </select>
  );
};

export default InsuranceMenu;
